import {
  SitecoreContextResourceType,
  TenantApplicationNode,
} from '../types/types';

export const getDeploymentInfoSync = (
  resources: SitecoreContextResourceType[] | undefined,
  applicationsNodes: TenantApplicationNode[],
): { projectId: string; environmentId: string } | null => {
  if (!resources || resources.length === 0) {
    return null;
  }
  if (!applicationsNodes || applicationsNodes.length === 0) {
    return null;
  }

  try {
    const relevantResources = resources.filter(
      (r) =>
        r.tenantProductCode === 'Edge' || r.tenantProductCode === 'XMCloud',
    );

    if (relevantResources.length === 0) {
      return null;
    }

    const sortedResources = [...relevantResources].sort((a, b) => {
      const aHasSlash = a.tenantName?.includes('/') ? 1 : 0;
      const bHasSlash = b.tenantName?.includes('/') ? 1 : 0;
      return bHasSlash - aHasSlash;
    });

    for (const resource of sortedResources) {
      if (!resource.tenantId) {
        continue;
      }

      const tenantNode = applicationsNodes.find(
        (node) => node.id === resource.tenantId,
      );
      if (!tenantNode) {
        continue;
      }

      const extractedInfo = extractAnnotationValues(tenantNode);
      if (extractedInfo) {
        return extractedInfo;
      }
    }

    for (const node of applicationsNodes) {
      const projectId = node.annotations.find(
        (a) =>
          a.key === 'XMCloud.ProjectId' ||
          a.key === 'XmCloud.ProjectId' ||
          (a.key.toLowerCase().includes('project') &&
            a.key.toLowerCase().includes('id')),
      )?.value;

      const environmentId = node.annotations.find(
        (a) =>
          a.key === 'XMCloud.EnvironmentId' ||
          a.key === 'XmCloud.EnvironmentId' ||
          (a.key.toLowerCase().includes('environment') &&
            a.key.toLowerCase().includes('id')),
      )?.value;

      if (projectId && environmentId) {
        return { projectId, environmentId };
      }
    }

    return null;
  } catch (error) {
    return null;
  }
};

const extractAnnotationValues = (
  tenantNode: TenantApplicationNode,
): {
  projectId: string;
  environmentId: string;
} | null => {
  const projectIdKeys = ['XMCloud.ProjectId', 'XmCloud.ProjectId'];
  const environmentIdKeys = ['XMCloud.EnvironmentId', 'XmCloud.EnvironmentId'];

  let projectId = '';
  let environmentId = '';

  for (const key of projectIdKeys) {
    const value = tenantNode.annotations.find((a) => a.key === key)?.value;
    if (value) {
      projectId = value;
      break;
    }
  }

  for (const key of environmentIdKeys) {
    const value = tenantNode.annotations.find((a) => a.key === key)?.value;
    if (value) {
      environmentId = value;
      break;
    }
  }

  if (!projectId) {
    const projectAnnotation = tenantNode.annotations.find(
      (a) =>
        a.key.toLowerCase().includes('project') &&
        a.key.toLowerCase().includes('id'),
    );
    if (projectAnnotation) {
      projectId = projectAnnotation.value;
    }
  }

  if (!environmentId) {
    const envAnnotation = tenantNode.annotations.find(
      (a) =>
        a.key.toLowerCase().includes('environment') &&
        a.key.toLowerCase().includes('id'),
    );
    if (envAnnotation) {
      environmentId = envAnnotation.value;
    }
  }

  if (!projectId || !environmentId) {
    return null;
  }

  return { projectId, environmentId };
};
